import React from 'react';
import Sponsor from './Sponsor';

const Block = ({ data, isEditMode, id }) => {
  return (
    <div className="sponsor-container">
      {data.description && (
        <div className="text text-center">{data.description}</div>
      )}

      {data.sponsors?.map((s, index) => {
        return <Sponsor sponsor={s} isEditMode={isEditMode} key={id} id={id} />;
      })}
    </div>
  );
};

export default Block;
